module.exports = __webpack_public_path__ + "static/media/testing.b560d00d.svg";